import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { LoginService } from "../pages/login/services/login.service";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private loginService: LoginService
  ) {}

  canActivate(): boolean {
    if (!this.loginService.hasToken()) {
      this.router.navigateByUrl('/login', { replaceUrl: true });
      return false;
    }
    return true;
  }
}
